import { SxProps, Theme } from "@mui/material/styles";

const styles: SxProps<Theme> = [
  {
    "& .button": {
      boxShadow: "none",
      borderRadius: "0",
      minWidth: 40,
      width: 40,
      height: 40,
      padding: 0,
      marginRight: "12px",
      marginBottom: 3,
    },
    "& .infoText": {
      fontWeight: "bold",
      marginBottom: 3,
    },
    "& .formRechercherAdb": {
      padding: "34px",
      width: "100%",
      margin: 0,
    },
    "& .bouton": {
      "& button": {
        float: "right",
      },
    },
    "& .legend": {
      mt: 4,
      "& svg": {
        mr: 1,
      },
    },
  },
];

export default styles;
